import { render, staticRenderFns } from "./detail_groupLecture.vue?vue&type=template&id=b1ad66c8&scoped=true&"
import script from "./detail_groupLecture.vue?vue&type=script&lang=js&"
export * from "./detail_groupLecture.vue?vue&type=script&lang=js&"
import style0 from "./detail_groupLecture.vue?vue&type=style&index=0&id=b1ad66c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ad66c8",
  null
  
)

export default component.exports